import { DetailTitleComponent, CustomButton } from '@/shared/ui/components';
import classNames from 'classnames';
import { t } from 'ttag';
import { useShippingLabelHeader } from './useShippingLabelHeader';

/**
 * Renders the sticky header of the create-shipping-label page. Takes the scroll flag and back handler from its hook, adds a box-shadow class once the page is scrolled, and renders the Create shipping label title with a Create button wired to props.handleCreateClick and disabled state.
 *
 * @param props - Header props carrying isLoadedData, disabled and handleCreateClick.
 * @returns The page header markup.
 */
const ShippingLabelHeader = (props: any) => {
  const { isScroll, handlBackClick } = useShippingLabelHeader();

  return (
    <div
      className={classNames('create-return-shipping-header', {
        '--has-box-shadow': isScroll,
      })}
    >
      <DetailTitleComponent
        isLoadedData={props.isLoadedData}
        title={t`Create shipping label`}
        rightComponent={
          <CustomButton
            id="create-return-shipping-btn"
            onClick={props.handleCreateClick}
            disabled={props.disabled}
            type="primary"
            style="default"
            size="small"
          >
            {t`Create`}
          </CustomButton>
        }
        handleClickBack={handlBackClick}
      />
    </div>
  );
};

export default ShippingLabelHeader;
